/** Same labels/durations as CustomFilters DatePicker quick presets. */
export const QUICK_DATE_RANGE_OPTIONS = [
  { label: 'Last 15 min', ms: 15 * 60 * 1000 },
  { label: 'Last 30 min', ms: 30 * 60 * 1000 },
  { label: 'Last 1 hour', ms: 60 * 60 * 1000 },
  { label: 'Last 3 hours', ms: 3 * 60 * 60 * 1000 },
  { label: 'Last 6 hours', ms: 6 * 60 * 60 * 1000 },
  { label: 'Last 9 hours', ms: 9 * 60 * 60 * 1000 },
  { label: 'Last 24 hours', ms: 24 * 60 * 60 * 1000 },
  { label: 'Last 3 days', ms: 3 * 24 * 60 * 60 * 1000 },
  { label: 'Last week', ms: 7 * 24 * 60 * 60 * 1000 },
  { label: 'Last 2 weeks', ms: 14 * 24 * 60 * 60 * 1000 },
  { label: 'Last 4 weeks', ms: 28 * 24 * 60 * 60 * 1000 },
];

const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

/** Local datetime string (no timezone suffix); matches DatePicker / filter storage. */
export const formatLocalDateTime = (localDate, includeMs = false) => {
  const base = `${localDate.getFullYear()}-${pad(localDate.getMonth() + 1)}-${pad(localDate.getDate())}T${pad(localDate.getHours())}:${pad(localDate.getMinutes())}:${pad(localDate.getSeconds())}`;
  if (!includeMs) return base;
  const ms = String(localDate.getMilliseconds()).padStart(3, '0');
  return `${base}.${ms}`;
};

export const getQuickRangeMs = (quickLabel) => {
  if (!quickLabel) return null;
  const opt = QUICK_DATE_RANGE_OPTIONS.find((o) => o.label === quickLabel);
  return opt ? opt.ms : null;
};

/**
 * Rolling window for a quick preset, anchored at `now`.
 * @returns {{ start_date: string, end_date: string } | null}
 */
export const computeQuickRangeDates = (quickLabel, now = new Date()) => {
  const ms = getQuickRangeMs(quickLabel);
  if (ms == null) return null;
  const start = new Date(now.getTime() - ms);
  return {
    start_date: formatLocalDateTime(start),
    end_date: formatLocalDateTime(now, true),
  };
};

/** Recompute include date_picker range from quickLabel (rolling window anchored at now). */
export const applyQuickLabelRollingToDateParams = (filtersList, params = {}) => {
  const dp = filtersList?.find(
    (f) => f.filterType === 'date_picker' && f.id === 'date_picker',
  );
  const ql = dp?.value?.quickLabel;
  if (!ql) return params;
  const rolling = computeQuickRangeDates(ql);
  if (!rolling) return params;
  return {
    ...params,
    start_date: rolling.start_date,
    end_date: rolling.end_date,
  };
};

/** Refresh stored date_picker value when a quick preset is active. */
export const refreshQuickLabelDateValue = (value) => {
  if (!value?.quickLabel) return value;
  const rolling = computeQuickRangeDates(value.quickLabel);
  if (!rolling) return value;
  return {
    ...value,
    start_date: rolling.start_date,
    end_date: rolling.end_date,
    quickLabel: value.quickLabel,
  };
};
